export default "__VITE_ASSET__CYL0Di_I__"